import React, { useState, useEffect } from 'react';
import { PostDataAPI } from './services/PostDataAPI';
import Header from './components/header';
import Footer from './components/footer';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import SEOTags from './common/SEO';

const NewsDetails = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    
    // Router fallback state if user came from a link click
    const newsItem = location.state?.newsItem;
    const _baseURL = process.env.REACT_APP_BASE_URL || "";

    const [newsDetails, setNewsDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // 1. Fetch data from API
    const fetchNews = async () => {
        setLoading(true);
        try {
            const result = await PostDataAPI("news/getNewsDetails", id);
            if (result.success && result.data) {
                setNewsDetails(result.data);
            } else {
                setError(result.message || "No news available.");
                navigate('/not-found');
            }
        } catch (err) {
            if (err.name !== 'AbortError') {
                setError("Failed to fetch news: " + err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    // 2. Trigger fetch whenever the URL parameter ID changes
    useEffect(() => {
        if (id) {
            fetchNews();
        }
    }, [id]);

    // 3. THIS FIXES THE TITLE: Runs dynamically exactly when newsDetails finishes updating
    useEffect(() => {
        if (newsDetails) {
            const newsTitle = newsDetails.title || "Check out this news!";
            const metaDescription = newsDetails.metaDescription || "";
            const metaTitle = newsDetails.metaTitle || newsTitle;
            const image = newsDetails.newsPhotoPath ? `${_baseURL}${newsDetails.newsPhotoPath}` : "";
            const url = `${_baseURL}/#/${newsDetails.slug || ""}`;

            // Fire the SEO function with the final payload
            SEOTags(newsTitle, metaDescription, metaTitle, image, url);
        }
    }, [newsDetails, _baseURL]);

    return (
        <>
            <Header />
            <section
                style={{
                    backgroundImage: `linear-gradient(rgb(0 0 0 / 93%), rgb(0 0 0 / 83%)), url(${"/" + (newsDetails?.bannerPath || newsItem?.bannerPath || "")})`,
                    backgroundSize: "cover",
                    backgroundPosition: "right",
                }}
                className="sub-hero pa-hero">
                <div className="container">
                    {/* Shows the fetched title, or falls back to routing state title */}
                    <h1>{newsDetails?.title || newsItem?.title}</h1>
                    <p>{newsDetails?.shortDescription || newsItem?.shortDescription}</p>
                </div>
            </section>

            <section className="about" id="about">
                <div className="container">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <div className={'news-detail-container'}>
                                <img
                                    src={"/" + (newsDetails?.bannerPath || newsItem?.bannerPath || "")}
                                    style={{ width: "100%" }}
                                    alt="News Banner"
                                />
                                <div className='news-content'>
                                    <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
                                        {newsDetails?.title}
                                    </Typography>
                                    <div 
                                        style={{ padding: '10px 0' }} 
                                        dangerouslySetInnerHTML={{ __html: newsDetails?.longDescription || newsItem?.longDescription || "" }}
                                    ></div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default NewsDetails;
